import { arrayOf, oneOf, shape, string } from 'prop-types';

export default shape({
  label: string,
  value: string,
  key: string,
  type: oneOf(['number', 'trend']),
  range: string,
  subCells: arrayOf(string),
  customerName: string,
});
